<template>
  <div class="home_view">
    <div class="center">
      <SearchBar />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "HomeView",
  components: {
    SearchBar,
  },
};
</script>

<style scoped>
.center {
  text-align: center;
  padding: 0;
  max-width: 600px;
}
</style>